// eslint-disable-next-line no-undef
export default envConfig;
